module.exports = __webpack_public_path__ + "files/8acfb00c61c17473dd82234e29ea1954.svg";